export const menuList: {
  key: string;
  text: string;
  url: string;
}[] = [
  {
    key: "cugate",
    text: "CuGate",
    url: "/cugate",
  },
  {
    key: "cumarket",
    text: "CuMarket",
    url: "https://www.cumarket.net", //"/cumarket",
  },
  {
    key: "cuview",
    text: "CuView",
    url: "https://cumarket.net", // "/cuview",
  },
  {
    key: "curadio",
    text: "CuRadio",
    url: "https://curadio.cugate.com", //"/curadio",
  },
  {
    key: "cutrack",
    text: "CuTrack",
    url: "http://curadio.net", //"/cutrack",
  },
  {
    key: "playlists",
    text: "Playlists",
    url: "https://playlists.cugate.com", //"/playlists",
  },
  {
    key: "cusync",
    text: "CuSync",
    url: "http://cusync.cugate.com/index.html",
  },
];

export const menuRightList: {
  key: string;
  text: string;
  url: string;
  icon: number;
}[] = [
  {
    key: "our_team",
    text: "Our Team",
    url: "/our-team",
    icon: 0,
  },
  {
    key: "impressum",
    text: "Impressum",
    url: "/impressum",
    icon: 0,
  },
  {
    key: "privacy_policy",
    text: "Privacy Policy",
    url: "/privacy-policy",
    icon: 0,
  },
];

export const menuUserList: {
  key: string;
  text?: string;
  url?: string;
  icon?: number;
}[] = [
  {
    key: "dashboard",
    text: "Dashboard",
    url: "/dashboard",
    icon: 0,
  },
  {
    key: "profile",
    text: "My profile",
    url: "/profile",
    icon: 0,
  },
  {
    key: "membership",
    text: "Membership",
    url: "/membership",
    icon: 0,
  },
  {
    key: "divider",
  },
  {
    key: "all_labels",
    text: "Labels",
    url: "/all-labels",
    icon: 0,
  },
  {
    key: "all_members",
    text: "Artists",
    url: "/all-members",
    icon: 0,
  },
  // {
  //     key: "all_releases",
  //     text: "Releases",
  //     url: "/all-releases",
  //     icon: 0,
  // },
  {
    key: "all_tracks",
    text: "Tracks",
    url: "/all-tracks",
    icon: 0,
  },

  {
    key: "divider",
  },
  {
    key: "our_team",
    text: "Our Team",
    url: "/our-team",
    icon: 0,
  },
  {
    key: "impressum",
    text: "Impressum",
    url: "/impressum",
    icon: 0,
  },
  {
    key: "privacy_policy",
    text: "Privacy Policy",
    url: "/privacy-policy",
    icon: 0,
  },
  // {
  //     key: "help_center",
  //     text: "Help Center",
  //     url: "/",
  //     icon: 0,
  // },
  // {
  //     key: "how_it_works",
  //     text: "How it works",
  //     url: "/",
  //     icon: 0,
  // },
  // {
  //     key: "news",
  //     text: "News",
  //     url: "/",
  //     icon: 0,
  // },

  {
    key: "divider",
  },
  {
    key: "logout",
    text: "logout",
    url: "/",
    icon: 0,
  },
];
